var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4 11.4308L4.9846 8.0154L5.8278 7.1478L7.8 9.12V2.4H9V9.12L10.9722 7.1478L11.8154 8.0154L8.4 11.4308ZM3.8462 14.4C3.44207 14.4 3.1 14.26 2.82 13.98C2.54 13.7 2.4 13.3579 2.4 12.9538V10.7846H3.6V12.9538C3.6 13.0154 3.62567 13.0718 3.677 13.123C3.7282 13.1743 3.7846 13.2 3.8462 13.2H12.9538C13.0154 13.2 13.0718 13.1743 13.123 13.123C13.1743 13.0718 13.2 13.0154 13.2 12.9538V10.7846H14.4V12.9538C14.4 13.3579 14.26 13.7 13.98 13.98C13.7 14.26 13.3579 14.4 12.9538 14.4H3.8462Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/download_2.7d1d03800b1ed2c0f18f0a93066b2be3.svg";
export { ForwardRef as ReactComponent };